import { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router';
import {
  BackButton,
  Box,
  Center,
  FloatingContainer,
  Row,
  Screen,
  Stepper,
  Text,
} from '~/commonComponents';
import { CreatePermanentJobPostingSteps } from './Types';
import { useCurrentPermanentJobPostingSlug } from './hooks';

export const CreatePermanentJobsPage = () => {
  const location = useLocation();
  const slug = useCurrentPermanentJobPostingSlug();

  // Scroll to top on navigation
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  const currentStepIndex = useMemo(() => {
    if (slug === CreatePermanentJobPostingSteps.ReviewAndPayment) {
      return 1;
    }

    return 0;
  }, [slug]);

  return (
    <Screen>
      <FloatingContainer borderRadius={4} paddingBlock={48} paddingInline={16}>
        <Row position="relative" alignItems="center" justifyContent="center">
          <Box position="absolute" left={0}>
            <BackButton />
          </Box>
          <Text bold fontSize={32} textAlign="center">
            Post a Job
          </Text>
        </Row>
        <Center marginTop={24} width={360} marginBottom={40}>
          <Stepper currentStep={currentStepIndex} steps={['Job Details', 'Review and Payment']} />
        </Center>
        <Outlet />
      </FloatingContainer>
    </Screen>
  );
};
